import * as React from 'react';
import { Translate } from '../../../../../../../shared/LanguageService';
import ConfirmDialog from '../../../shared/dialog/view/ConfirmDialog';
import { ICost } from '../../../../../../../shared/localization/currency';

type ConfirmExtraImagePurchaseDialogProps = {
    open: boolean;
    extraImageCost: ICost | null;
    onConfirm: () => void;
    onCancel: () => void;
};

export function ConfirmExtraImagePurchaseDialog({
    open,
    extraImageCost,
    onConfirm,
    onCancel
}: ConfirmExtraImagePurchaseDialogProps) {
    return (
        <ConfirmDialog
            open={open}
            title={Translate(
                'image-processing/customer/post-approval/confirm-extra-image-purchase/title'
            )}
            text={
                extraImageCost !== null
                    ? Translate(
                          'image-processing/customer/post-approval/confirm-extra-image-purchase/text',
                          {
                              extraImageCost: extraImageCost.toString()
                          }
                      )
                    : Translate(
                          'image-processing/customer/post-approval/confirm-extra-image-purchase/text-without-price'
                      )
            }
            confirmLabel={Translate('image-processing/page/status-actions/button-label/approve')}
            cancelLabel={Translate('delete/modal/footer/button-label/cancel')}
            onConfirm={() => {
                onConfirm();
            }}
            onCancel={() => {
                onCancel();
            }}
        />
    );
}
